// Central data-testid registry — extended for admin & polls
export const HOME = { emergentLink: "home-emergent-link" };

export const NAV = {
  radio: "nav-tab-radio",
  tv: "nav-tab-tv",
  music: "nav-tab-music",
  instagram: "nav-tab-instagram",
  contact: "nav-tab-contact",
  logo: "app-logo",
};

export const RADIO = {
  playPause: "radio-live-play-pause",
  liveBadge: "radio-live-badge",
  volume: "radio-live-volume",
  goLibrary: "radio-goto-library",
  librarySearch: "radio-library-search",
  libraryCard: (id) => `radio-episode-card-${id}`,
  libraryPlay: (id) => `radio-episode-play-${id}`,
  filterChip: (id) => `radio-filter-${id}`,
};

export const TV = {
  playPause: "tv-live-play-pause",
  video: "tv-live-video",
  liveBadge: "tv-live-badge",
  goLibrary: "tv-goto-library",
  librarySearch: "tv-library-search",
  libraryCard: (id) => `tv-video-card-${id}`,
  libraryPlay: (id) => `tv-video-play-${id}`,
  youtubeFrame: "tv-live-youtube-iframe",
};

export const MINI = {
  root: "mini-player-root",
  toggle: "mini-player-toggle",
  close: "mini-player-close",
  title: "mini-player-title",
};

export const IG = {
  refresh: "instagram-refresh",
  post: (id) => `instagram-post-${id}`,
  follow: "instagram-follow-btn",
};

export const CIDADAO = {
  cardComplaint: "contact-card-complaint",
  cardReport: "contact-card-report",
  whatsapp: "contact-whatsapp",
  email: "contact-email",
  pollsSection: "cidadao-polls-section",
  pollCard: (id) => `poll-card-${id}`,
  pollOption: (pid, oid) => `poll-${pid}-option-${oid}`,
  pollVote: (pid) => `poll-${pid}-vote-btn`,
};

export const COMPLAINT_FORM = {
  name: "complaint-name",
  phone: "complaint-phone",
  type: "complaint-type",
  description: "complaint-description",
  photo: "complaint-photo",
  location: "complaint-location",
  submit: "complaint-submit",
  successModal: "complaint-success-modal",
  successClose: "complaint-success-close",
};

export const REPORT_FORM = {
  name: "report-name",
  phone: "report-phone",
  description: "report-description",
  location: "report-location",
  when: "report-when",
  media: "report-media",
  submit: "report-submit",
  gps: "report-gps",
  successModal: "report-success-modal",
  successClose: "report-success-close",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  logout: "admin-logout",
  nav: {
    dashboard: "admin-nav-dashboard",
    ads: "admin-nav-ads",
    radio: "admin-nav-radio",
    tv: "admin-nav-tv",
    polls: "admin-nav-polls",
    citizens: "admin-nav-citizens",
    reports: "admin-nav-reports",
  },
  ads: {
    newBtn: "admin-ads-new",
    row: (id) => `admin-ad-row-${id}`,
    toggle: (id) => `admin-ad-toggle-${id}`,
    delete: (id) => `admin-ad-delete-${id}`,
    formTitle: "admin-ad-title",
    formSponsor: "admin-ad-sponsor",
    formImage: "admin-ad-image",
    formTarget: "admin-ad-target",
    formPlacement: "admin-ad-placement",
    formSubmit: "admin-ad-submit",
  },
  radio: {
    programName: "admin-radio-program",
    host: "admin-radio-host",
    cover: "admin-radio-cover",
    streamUrl: "admin-radio-stream",
    startBtn: "admin-radio-start",
    stopBtn: "admin-radio-stop",
  },
  tv: {
    programName: "admin-tv-program",
    description: "admin-tv-description",
    sourceType: "admin-tv-source-type",
    streamUrl: "admin-tv-stream",
    youtubeId: "admin-tv-youtube",
    saveBtn: "admin-tv-save",
    newVideoBtn: "admin-tv-new-video",
    playlistNewBtn: "admin-tv-playlist-new",
  },
  polls: {
    newBtn: "admin-polls-new",
    question: "admin-poll-question",
    option: (i) => `admin-poll-option-${i}`,
    addOption: "admin-poll-add-option",
    submit: "admin-poll-submit",
    row: (id) => `admin-poll-row-${id}`,
    toggle: (id) => `admin-poll-toggle-${id}`,
    delete: (id) => `admin-poll-delete-${id}`,
  },
};

export const AD_BANNER = {
  root: (id) => `ad-banner-${id}`,
};
